import { get, post, put } from '../index'

export async function getTrainerConfig (data: { releaseStatus: string }) {
  return await post('/certification/trainerTeam/queryTrainerConfig', data)
}

export async function getTrainerBannerConfig (data: { typeList: string[] }) {
  return await post('/certification/banner/release/query', data)
}

export async function getVerificationCode () {
  return await get('/certification/validateCode/getValidateCode')
}

export async function uploadFile (data: File) {
  return await put('/certification/trainerTeam/file/upload', {
    name: 'file',
    file: data
  })
}
